module.exports = __webpack_public_path__ + "9b2255e36346e503bb97e94c2f381416.png";